import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';

import App from './js/App';
import NotFound from './js/NotFound';
import Verified from "./js/Verified";
import TechnicalError from './js/TechnicalError';
import Expired from "./js/Expired";

ReactDOM.render(<Router>
    <div>
        <Switch>
            <Route exact path="/" render={(props) => (<App {...props}/>)}/>
            <Route exact path="/verified" render={(props) => (<Verified {...props}/>)}/>
            <Route exact path="/expired" render={(props) => (<Expired {...props}/>)}/>
            <Route exact path="/technicalError" render={(props) => (<TechnicalError {...props}/>)}/>
            <Route component={NotFound}/>
        </Switch>
    </div>
</Router>, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js